import React, { useEffect, useRef } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import AddTradingCompanyInformation from '../components/manage-news/AddTradingCompanyInformation';
import GridTradingCompanyInformation from '../components/manage-news/GridTradingCompanyInformation';
import TextFiltering from '../components/common/ag-grid/TextFiltering';
import AddNews from '../components/manage-news/AddNews';
import GridNews from '../components/manage-news/GridNews';
import ModalEditTradingCompanyInformation from '../components/manage-news/ModalEditTradingCompanyInformation';
import ModalEditNews from '../components/manage-news/ModalEditNews';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { getTradingCompanyInformationsForManage, resetServerMessage as resetServerMessageInfo } from '../redux/slices/manageTradingCompanyInformation';
import { getNewss, getNewssForManage, resetServerMessage as resetMessageNews } from '../redux/slices/news';
import { getUsers } from '../redux/slices/user';
import type { AgGridReact as AgGridReactType } from 'ag-grid-react/lib/agGridReact';

const ManageNews = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError: hasErrorInfo, serverMessage: serverMessageInfo } = useSelector((state: RootState) => state.manageTradingCompanyInformation);
  const { hasError: hasErrorNews, serverMessage: serverMessageNews, newssForManage } = useSelector((state: RootState) => state.news);
  const gridRef = useRef<AgGridReactType>(null);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 初期データの取得
  useEffect(() => {
    dispatch(getUsers({}));
    dispatch(getTradingCompanyInformationsForManage());
    dispatch(getNewssForManage());
  }, []);

  useEffect(() => {
    dispatch(getNewss());
  }, [newssForManage]);

  // EVENT HANDLER
  // ================================================================================

  /**
   * メッセージを消す
   */
  const dismissInfo = (): void => {
    dispatch(resetServerMessageInfo());
  };
  const dismissNews = (): void => {
    dispatch(resetMessageNews());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('information.manage')} subtitle="Manage Information" className="text-sm-left" />
      </Row>

      {/* 緊急通知編集
      ---------------------------------------- */}
      <div id="manageTradingCompanyInformation" className="mb-4">
        <Notification theme={hasErrorInfo ? 'danger' : 'success'} isOpen={serverMessageInfo !== undefined && serverMessageInfo.length > 0} message={serverMessageInfo} dismissCallback={dismissInfo} />

        <Row className="mb-4">
          <Col md="2" sm="6" className="d-flex align-items-center">
            <h5 className="mb-0">{t('information.alert.manage')}</h5>
          </Col>
          <Col md="3" sm="6">
            <AddTradingCompanyInformation />
          </Col>
        </Row>

        <GridTradingCompanyInformation />
        <ModalEditTradingCompanyInformation />
      </div>

      {/* インフォメーション編集
      ---------------------------------------- */}
      <div id="manageNew">
        <Notification theme={hasErrorNews ? 'danger' : 'success'} isOpen={serverMessageNews !== undefined && serverMessageNews.length > 0} message={serverMessageNews} dismissCallback={dismissNews} />

        <Row className="mb-4">
          <Col md="3" sm="6">
            <h5 className="mb-0">{t('information.news.manage')}</h5>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md="3" sm="6">
            <TextFiltering gridRef={gridRef} />
          </Col>
          <Col md="3" sm="6">
            <AddNews />
          </Col>
        </Row>

        <GridNews ref={gridRef} />
        <ModalEditNews />
      </div>
    </Container>
  );
};

export default ManageNews;
